import { CopyingToClipboardForbidden } from '@f/error-decorators/errors/common';

export async function copyToClipboard(text: string) {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      if (error instanceof Error) {
        console.error('Failed to use clipboard API: %s', error.stack);
      }
      throw new CopyingToClipboardForbidden({ errors: [error] });
    }
  } else {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text.replace(/\n/gi, '\r\n');
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  }
}
